@if (text) {
  <button
    type="button"
    class="info-tip"
    #tip="matTooltip"
    [matTooltip]="text"
    [matTooltipPosition]="position"
    matTooltipClass="info-tip__bubble"
    matTooltipTouchGestures="off"
    [attr.aria-label]="ariaLabel"
    (click)="onClick($event, tip)"
    (keydown.escape)="tip.hide(0)"
  >
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <circle cx="7" cy="7" r="6.25" stroke="currentColor" stroke-width="1.3" />
      <path d="M7 6.2v3.6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
      <circle cx="7" cy="4.3" r="0.8" fill="currentColor" />
    </svg>
  </button>
}
